// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__14Q-G","rootSuccess":"CompleteLink_rootSuccess__3HBfc","rootFailure":"CompleteLink_rootFailure__2NLvR","isDisabled":"CompleteLink_isDisabled__2Ll1u"};